import { useCallback, useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import {
  trunkSessionNew,
  loginSession,
  sendOtpEmail,
  checkUserValidSignupUser,
  trunkJoinMember,
  trunkSessionLogout,
  trunkSendPasswordInit,
  trunkGetGoogleOTPInfo,
  trunkRegisterGoogleOTPInfo,
  trunkCheckOtpEmail,
  trunkLoginGoogleOtp,
  trunkGetAlarmList,
  trunkReadAlarm,
  trunkReadAllAlarm,
  trunkGetFileSimpleInfo,
  trunkGetFileUrlDownloadFromUid,
  trunkGetFileUrlFromUid,
  trunkGetInformationFromUid,
  trunkGetLogInByUid,
  trunkChangePasswordFromMail,
  trunkPollingEsetAuthenticate,
  trunkStartEsetAuthenticate,
  trunkDocHtmlDownload,
} from "../store/login";
import { bindActionCreators } from "redux";
import { UserChangePasswordFromMailDTO, UserMemberDto } from "../../types/auth";
import { AlarmRequest } from "../../types/common";

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useLoginStore = () => {
  const loginState = useRootState((state) => state.loginStore);

  const dispatch = useAppDispatch();

  const boundSessionNew = useCallback(
    () => dispatch(trunkSessionNew()).then(),
    [dispatch]
  );
  const boundSessionLogout = useCallback(
    () => dispatch(trunkSessionLogout()).then(),
    [dispatch]
  );
  const boundLoginSession = useMemo(
    () => bindActionCreators(loginSession, dispatch),
    [dispatch]
  );
  const boundGetLogInByUid = useMemo(
    () => bindActionCreators(trunkGetLogInByUid, dispatch),
    [dispatch]
  );
  const boundSendOtpEmail = useMemo(
    () => bindActionCreators(sendOtpEmail, dispatch),
    [dispatch]
  );
  const boundCheckOtpEmail = useMemo(
    () => bindActionCreators(trunkCheckOtpEmail, dispatch),
    [dispatch]
  );
  const boundCheckUserValidSignupUser = useCallback(
    (userId: string) => dispatch(checkUserValidSignupUser(userId)).then(),
    [dispatch]
  );
  const boundJoinMember = useCallback(
    (uuid: string, users: UserMemberDto[]) =>
      dispatch(trunkJoinMember({ uuid, users })).then(),
    [dispatch]
  );
  const boundSendPasswordInit = useCallback(
    (userId: string) => dispatch(trunkSendPasswordInit(userId)).then(),
    [dispatch]
  );
  const boundGetGoogleOTPInfo = useCallback(
    (userId: string) => dispatch(trunkGetGoogleOTPInfo(userId)).then(),
    [dispatch]
  );
  const boundRegisterGoogleOTPInfo = useCallback(
    (userId: string) => dispatch(trunkRegisterGoogleOTPInfo(userId)).then(),
    [dispatch]
  );
  const boundStartEsetLogin = useCallback(
    (userId: string) => dispatch(trunkStartEsetAuthenticate(userId)).then(),
    [dispatch]
  );
  const boundPollingEsetLogin = useCallback(
    (req: { pushChallengeId: string; userId: string }) =>
      dispatch(trunkPollingEsetAuthenticate(req)).then(),
    [dispatch]
  );
  const boundLoginGoogleOtp = useCallback(
    (req: { userId: string; otp: string }) =>
      dispatch(trunkLoginGoogleOtp(req)).then(),
    [dispatch]
  );
  const boundGetAlarmList = useCallback(
    (reqDto: AlarmRequest) => dispatch(trunkGetAlarmList(reqDto)).then(),
    [dispatch]
  );
  const boundReadAlarm = useCallback(
    (reqDto: AlarmRequest) => dispatch(trunkReadAlarm(reqDto)).then(),
    [dispatch]
  );
  const boundReadAllAlarm = useCallback(
    (reqDto: AlarmRequest) => dispatch(trunkReadAllAlarm(reqDto)).then(),
    [dispatch]
  );
  const boundGetInformationFromUid = useCallback(
    (uid: string) => dispatch(trunkGetInformationFromUid(uid)).then(),
    [dispatch]
  );
  const boundGetFileUrlFromUid = useCallback(
    (req: { uid: string; token?: string }) =>
      dispatch(trunkGetFileUrlFromUid(req)).then(),
    [dispatch]
  );
  const boundGetFileUrlDownloadFromUid = useCallback(
    (req: { uid: string; token?: string }) =>
      dispatch(trunkGetFileUrlDownloadFromUid(req)).then(),
    [dispatch]
  );
  const boundGetFileSimpleInfo = useCallback(
    (syncId: string) => dispatch(trunkGetFileSimpleInfo(syncId)).then(),
    [dispatch]
  );
  const boundChanegPasswordFromMail = useCallback(
    (req: UserChangePasswordFromMailDTO, initOtp: boolean) =>
      dispatch(trunkChangePasswordFromMail({ req, initOtp })).then(),
    [dispatch]
  );

  const boundDocHtmlDownload = useCallback(
    (req: {
      uid: string;
      syncId: string;
      revisionNo: string;
      startDownload: any;
    }) => {
      return dispatch(trunkDocHtmlDownload(req)).then();
    },
    [dispatch]
  );
  return {
    loginState,
    sessionNew: boundSessionNew,
    sessionLogout: boundSessionLogout,
    loginSession: boundLoginSession,
    sendOtpEmail: boundSendOtpEmail,
    checkOtpEmail: boundCheckOtpEmail,
    checkUserValidSignupUser: boundCheckUserValidSignupUser,
    setJoinMember: boundJoinMember,
    sendPasswordInit: boundSendPasswordInit,
    getGoogleOTPInfo: boundGetGoogleOTPInfo,
    registerGoogleOTPInfo: boundRegisterGoogleOTPInfo,
    loginGoogleOtp: boundLoginGoogleOtp,
    getAlarmList: boundGetAlarmList,
    readAlarm: boundReadAlarm,
    readAllAlarm: boundReadAllAlarm,
    getInformationFromUid: boundGetInformationFromUid,
    getFileUrlFromUid: boundGetFileUrlFromUid,
    getFileUrlDownloadFromUid: boundGetFileUrlDownloadFromUid,
    getFileSimpleInfo: boundGetFileSimpleInfo,
    getLogInByUid: boundGetLogInByUid,
    changePasswordFromMail: boundChanegPasswordFromMail,
    startEsetLogin: boundStartEsetLogin,
    pollingEsetLogin: boundPollingEsetLogin,
    getDocHtmlDownload: boundDocHtmlDownload,
  };
};

export default useLoginStore;
